angular.module('offlineChecker')
  .filter('reservationFilter',reservationFilter);

  function reservationFilter(){
    return function(reservations, searchIndex, searchFor){
      if(!Array.isArray(reservations)){
        return reservations;
      }
      if(typeof searchIndex !== "number"){
        return reservations;
      }
      if(reservations.length === 0){
        return reservations;
      }
      if(searchIndex >= reservations[0].length){
        return reservations;
      }
      if(!(searchIndex >= 0)){
        return reservations;
      }
      searchIndex -= (searchIndex % 1); // fix for floats being passed in
      if(typeof searchFor === 'string'){
        var out = [];
        angular.forEach(reservations, function(reservation){
          var searchAgainst = reservation[searchIndex];
          if(searchFor){
            if(searchAgainst !== null) {
              if (searchAgainst.toString().toLowerCase().indexOf(searchFor.toLowerCase()) > -1) {
                out.push(reservation);
              }
            }
          } else {
            out.push(reservation);
          }
        });
        return out;
      } else if (typeof searchFor === 'object') { //  date search
          var out = [];
          angular.forEach(reservations, function(reservation){
              var searchAgainst = reservation[searchIndex];
              if(searchFor){
                  if(searchAgainst !== null){
                      // compare the dates
                      if(moment(searchAgainst).startOf('day').isSame(moment(searchFor).startOf('day'))){
                          out.push(reservation);
                      }
                  }
              } else {
                  out.push(reservation);
              }
          });
          return out;
      } else {
          return reservations;
      }
    };
  }
